module.exports = __webpack_public_path__ + "static/media/2.dc972996.jpg";